import { render, staticRenderFns } from "./unitsManage.vue?vue&type=template&id=4f27fee8&"
import script from "./unitsManage.vue?vue&type=script&lang=js&"
export * from "./unitsManage.vue?vue&type=script&lang=js&"
import style0 from "./unitsManage.vue?vue&type=style&index=0&id=4f27fee8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports